import React, { Fragment, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Amjilt from "../../api/amjilt";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import "./Amjilt.css";
import Mcc from "../../components/mcc/Mcc";

const AmjiltPage = ({ isDark, onToggleDark }) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [modalIndex, setModalIndex] = useState(null); // modal нээх зурагны индекс

  const openModal = (index) => setModalIndex(index);
  const closeModal = () => setModalIndex(null);

  useEffect(() => {
    if (modalIndex !== null) {
      document.body.style.overflow = "hidden"; // scroll хаах
    } else {
      document.body.style.overflow = ""; // буцаах
    }

    // cleanup: компонент устахад буцаах
    return () => {
      document.body.style.overflow = "";
    };
  }, [modalIndex]);

  return (
    <Fragment>
      <motion.div
        intial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Header isDark={isDark} hclass={"header--styleFour"} />
        <main className="main">
          <PageTitle
            pageTitle={"Бидний амжилт"}
            pagesub={"бидний амжилт"}
            tolink={"#amjilts"}
          />
          <section className="events pt-70 pb-20" id="amjilts">
            <div className="container">
              <Mcc />
              {/* Эхний 2 зураг */}
              <div className="amjilt-first-row">
                {Amjilt.slice(0, 2).map((events, idx) => (
                  <div key={idx}>
                    <img
                      src={events.img}
                      alt="mongolsuvd"
                      className="amjilt-img"
                    />
                  </div>
                ))}
              </div>

              {/* Дараагийн зурагнууд */}
              <div className="amjilt-other-rows">
                {Amjilt.slice(2).map((events, idx) => (
                  <div key={idx + 2}>
                    <img
                      src={events.img}
                      alt="mongolsuvd"
                      className="amjilt-img"
                      onClick={() => openModal(idx + 2)}
                    />
                  </div>
                ))}
              </div>

              {/* Modal */}
              {modalIndex !== null && (
                <div className="amjilt-modal" onClick={closeModal}>
                  <div
                    className="amjilt-modal-content"
                    onClick={(e) => e.stopPropagation()} // modal дотор click-г хаахгүй
                  >
                    <span className="amjilt-modal-close" onClick={closeModal}>
                      &times;
                    </span>
                    <img src={Amjilt[modalIndex].img} alt="mongolsuvd" />
                  </div>
                </div>
              )}
            </div>
          </section>
        </main>
        <Footer isDark={isDark} onToggleDark={onToggleDark} />
        <Scrollbar />
      </motion.div>
    </Fragment>
  );
};

export default AmjiltPage;
